<template>
  <div>
    <CRow class="mb-4">
      <CCol v-if="advanced">
        <label v-translate translate-context="form_configurator.text.label">Field Key</label>
        <CInput v-model="key" @input="save" :placeholder="keyPlaceholder"/>
      </CCol>
      <CCol>
        <label v-translate translate-context="form_configurator.text.label">Field name</label>
        <PTranslatableTextInput v-model="name" @input="save" :langs="langs"/>
      </CCol>
    </CRow>
    <CRow class="mb-4" v-if="advanced">
      <CCol>
        <label v-translate translate-context="form_configurator.text.label">Field Size</label>
        <CSelect v-model="size" @change="save" :options="fieldSizeOptions"
                 :placeholder="$pgettext('form_configurator.text', 'Select field size')"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import PTranslatableTextInput from "@/domain/core/components/PTranslatableTextInput.vue";
import {generateKey, fieldSizeOptions, defaultFieldSize} from "@/domain/formConfigurator/fields";

export default {
  name: "FormTextInput",
  components: {PTranslatableTextInput},
  props: {
    data: {
      type: Object,
      required: true
    },
    advanced: {
      type: Boolean,
      required: true
    },
    langs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      key: '',
      keyPlaceholder: '',
      name: {},
      size: defaultFieldSize
    }
  },
  computed: {
    fieldSizeOptions() {
      return fieldSizeOptions
    }
  },
  emits: ['update:data'],
  watch: {
    data: function () {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.key = this.data.key ?? ''
      this.name = this.data.name ?? {}
      this.size = this.data.size ?? defaultFieldSize
      this.keyPlaceholder = generateKey(this.name)
    },
    save() {
      this.keyPlaceholder = generateKey(this.name)
      this.$emit('update:data', {
        ...this.data,
        key: this.key,
        name: this.name,
        size: this.size
      })
    }
  }
}
</script>